import { XMarkIcon } from '@heroicons/react/24/solid';
import Image from 'next/image';

import { DZFile } from '../../lib/image-upload';

interface ImagePreviewProps {
  file: DZFile;
  onDelete: (id: string) => void;
}

export default function ImagePreview({ file, onDelete }: ImagePreviewProps) {
  return (
    <div className="relative inline-flex rounded-md border-2 border-gray-300 p-1 dark:border-gray-600">
      <Image
        alt={file.id}
        width={130}
        height={60}
        src={file.preview}
        style={{ objectFit: 'contain' }}
        onLoad={() => URL.revokeObjectURL(file.preview)}
      />
      <button
        className="absolute top-1 right-1 rounded-full border-2 border-gray-500 bg-white/60 p-0.5 dark:border-gray-300 dark:bg-slate-900/60"
        onClick={() => onDelete(file.id)}
      >
        <XMarkIcon width={20} height={20} className="fill-gray-500 dark:fill-gray-300" />
      </button>
    </div>
  );
}
